module.exports = __webpack_public_path__ + "static/d-JMondragon-4450a892ca20a2d24df4eb2fbede0d9e.jpg";